import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal, checkIsPlatform } from '@airtel/air-design-system';
import { default as DateTimePicker } from '@react-native-community/datetimepicker';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { schedulingCalendarStyles } from './SchedulingCalendarStyles';
import { convertIntoDate } from '../../SchedulingWidgetUtils';
export var SchedulingCalendar = forwardRef((props, ref) => {
  var isIos = checkIsPlatform('ios');
  var visible = props.visible,
    selectedDate = props.selectedDate,
    actionCtaProps = props.actionCtaProps,
    changeSelectedDate = props.changeSelectedDate,
    onCalendarOpen = props.onCalendarOpen;
  var evtRef = useRef();
  var _useState = useState(selectedDate),
    datePickerValue = _useState[0],
    setDatePickerValue = _useState[1];
  useEffect(() => {
    setDatePickerValue(selectedDate);
  }, [selectedDate]);
  var onDonePress = () => {
    changeSelectedDate(evtRef.current, datePickerValue);
  };
  var onChangeDateTimePicker = (evt, date) => {
    var _a;
    var dateInMS = '';
    if (checkIsPlatform('web')) dateInMS = date;else dateInMS = (_a = date === null || date === void 0 ? void 0 : date.getTime()) === null || _a === void 0 ? void 0 : _a.toString();
    if (isIos) {
      evtRef.current = evt;
      setDatePickerValue(dateInMS);
    } else changeSelectedDate(evt, dateInMS);
  };
  var Wrapper = _ref => {
    var children = _ref.children;
    if (checkIsPlatform('android')) return _jsx(_Fragment, {
      children: !!visible && children
    });
    if (checkIsPlatform('web')) return _jsx(View, Object.assign({
      style: schedulingCalendarStyles.calendarContainer
    }, {
      children: children
    }));
  };
  var ButtonWrapper = _ref2 => {
    var children = _ref2.children;
    return checkIsPlatform('web') ? _jsx(View, Object.assign({
      style: schedulingCalendarStyles.openButton
    }, {
      children: children
    })) : _jsx(_Fragment, {
      children: children
    });
  };
  var renderDateTimePicker = () => {
    return _jsx(DateTimePicker, {
      value: convertIntoDate(datePickerValue),
      display: "spinner",
      mode: "date",
      onChange: onChangeDateTimePicker,
      minimumDate: convertIntoDate(actionCtaProps === null || actionCtaProps === void 0 ? void 0 : actionCtaProps.minimumDate),
      maximumDate: convertIntoDate(actionCtaProps === null || actionCtaProps === void 0 ? void 0 : actionCtaProps.maximumDate),
      style: checkIsPlatform('web') && schedulingCalendarStyles.calendarInput,
      onClick: () => checkIsPlatform('web') && onCalendarOpen()
    });
  };
  return _jsxs(_Fragment, {
    children: [_jsx(ButtonWrapper, {
      children: _jsx(Button, {
        title: actionCtaProps === null || actionCtaProps === void 0 ? void 0 : actionCtaProps.title,
        buttonType: "tertiary",
        version: "fixed-padding",
        style: schedulingCalendarStyles.actionCtaStyle,
        onPress: onCalendarOpen
      })
    }), isIos ? _jsxs(Modal, Object.assign({
      ref: ref,
      closeOnPressMask: true
    }, {
      children: [_jsx(View, Object.assign({
        style: schedulingCalendarStyles.iosDoneButton
      }, {
        children: _jsx(Button, {
          title: "DONE",
          buttonType: "tertiary",
          version: "fixed-padding",
          onPress: onDonePress
        })
      })), renderDateTimePicker()]
    })) : _jsx(Wrapper, {
      children: renderDateTimePicker()
    })]
  });
});